import React from 'react';
import cls from 'classname';

const ArrowLink = ({ width, height, color, className, style, ...props }) => (
  <svg width={width || '16'}
       height={height || '16'}
       fill={color ? color : '#225AEA'}
       className={cls(className, 'icon')}
       style={style} viewBox="0 0 16 16"
       xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0027 7.98659C10.0032 7.89926 9.98642 7.8127 9.95324 7.73186C9.92007 7.65102 9.87118 7.5775 9.80939 7.5155L7.14273 4.86147C7.08057 4.79961 7.00678 4.75054 6.92556 4.71706C6.84435 4.68357 6.7573 4.66634 6.66939 4.66634C6.58149 4.66634 6.49444 4.68357 6.41323 4.71706C6.33201 4.75054 6.25822 4.79961 6.19606 4.86147C6.1339 4.92334 6.08459 4.99678 6.05095 5.07761C6.01731 5.15844 6 5.24507 6 5.33256C6 5.42005 6.01731 5.50669 6.05095 5.58752C6.08459 5.66834 6.1339 5.74179 6.19606 5.80365L8.40273 7.98659L6.28273 10.1762C6.21453 10.2372 6.15973 10.3116 6.12174 10.3947C6.08375 10.4777 6.06339 10.5677 6.06194 10.659C6.06048 10.7503 6.07797 10.8408 6.11329 10.9251C6.14862 11.0093 6.20103 11.0854 6.26725 11.1485C6.33347 11.2117 6.41206 11.2606 6.49813 11.2921C6.58419 11.3237 6.67586 11.3372 6.76742 11.3319C6.85898 11.3266 6.94845 11.3025 7.03023 11.2612C7.11202 11.2199 7.18436 11.1622 7.24273 11.0918L9.81606 8.43777C9.9336 8.31643 10.0003 8.15512 10.0027 7.98659Z"
      />
  </svg>
);

export default ArrowLink;
